import type { Lead, LeadUpdate } from '../../api/types';

// Formularlogik für „Daten bearbeiten“ (LeadContactEdit.tsx): nur geänderte Felder senden, leere Felder löschen den Wert.

export const contactKeys = [
  'salutation',
  'first_name',
  'last_name',
  'company_name',
  'phone',
  'mobile_phone',
  'email',
  'street',
  'house_number',
  'postal_code',
  'city',
  'reachability',
] as const;

export type ContactKey = (typeof contactKeys)[number];
export type ContactForm = Record<ContactKey, string>;

export function contactForm(lead: Lead): ContactForm {
  return Object.fromEntries(contactKeys.map((k) => [k, lead[k] ?? ''])) as ContactForm;
}

// contactPatch: geänderte Felder (getrimmt); ein geleertes Feld wird zu null.
export function contactPatch(lead: Lead, form: ContactForm): LeadUpdate {
  const patch: LeadUpdate = {};
  for (const k of contactKeys) {
    const next = form[k].trim();
    if (next !== (lead[k] ?? '').trim()) patch[k] = next === '' ? null : next;
  }
  return patch;
}

const refreshed = new Set(['lead', 'focus', 'lead-owners', 'timeline', 'email-bounce', 'same-number', 'leads', 'appointment', 'appointment-history']);

// refreshKeys: Abfragen, die nach dem Speichern neu geladen werden (Akquise, Lead, Eigentümer, Chronik, Zustellprüfung).
export function refreshKeys(key: readonly unknown[], projectId: string): boolean {
  return key[0] === 'projects' && key[1] === projectId && typeof key[2] === 'string' && refreshed.has(key[2]);
}
